import { Channel, Topic } from "../../../constants";
import { call, takeLatest } from "redux-saga/effects";

import { HeaderActionConstants } from "../../action-constants";
import { MessageBrokerUtils } from "../../../utils";

function* openMyBets() {
  const funcProps = [
    {
      channel: Channel.SPORT,
      topic: Topic.preOpenMyBets,
      headers: { publisher: "unifiedclient" },
      data: {}
    }
  ];
  yield call(MessageBrokerUtils.publish, ...funcProps);
}

export default [takeLatest(HeaderActionConstants.OPEN_MY_BETS, openMyBets)];
